import { getPlatformComponent } from '@direct-frontend/platform-code';

export const TagTreeEditor = getPlatformComponent({
    desktop: import('./TagTreeEditor@desktop'),
    mobile: import('./TagTreeEditor@mobile'),
});
